const MULTIPLE_PRINT_AREAS_GUIDELINES_TOUCHED_KEY = 'multiplePrintAreasGuidelinesTouched';

export const isMultiplePrintAreasGuidelinesTouched = (): boolean =>
  !!window.localStorage.getItem(MULTIPLE_PRINT_AREAS_GUIDELINES_TOUCHED_KEY);

export const setMultiplePrintAreasGuidelinesTouched = (): void => {
  window.localStorage.setItem(MULTIPLE_PRINT_AREAS_GUIDELINES_TOUCHED_KEY, '1');
};
